import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';

import AboutPblMenuItem from './AboutPblMenuItem.js';

const AboutPblMenu = ({ clang, items }) => {
    return (
        <div className="about-pbl__menu">
            <ul className="about-pbl__menu-list">
                {items.sort((a, b) => a.menu_order - b.menu_order).map((item, index) =>
                    <AboutPblMenuItem key={index} {...item}/>)}
            </ul>
        </div>
    );
};

AboutPblMenu.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(AboutPblMenu));



// WEBPACK FOOTER //
// ./src/components/about/AboutPblMenu.js